import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter, Input } from '@angular/core';
import { Table } from 'primeng/table';
import { Subscription } from 'rxjs';
import { Message } from 'primeng/api';
import { TributacaoEmpresa } from 'src/app/admihair/api/dto/tributacao-empresa';
import { TributacaoEmpresaService } from 'src/app/admihair/service/tributacao-empresa.service';
import { Empresa } from 'src/app/admihair/api/dto/empresa';


@Component({
  selector: 'app-tributacao-listar',
  templateUrl: './tributacao-listar.component.html',
  styleUrls: ['./tributacao-listar.component.scss']
})
export class TributacaoListarComponent implements OnInit {

  messages: Message[] = [{ severity: '', summary: '', detail: '' }];
  messagemVisivel: boolean = false;
  listaTributacaoEmpresa: TributacaoEmpresa[] =[];
  eventBusSub?: Subscription;
  loading: boolean = false;
  @Input() empresa?: Empresa;
  @Output() emissor = new EventEmitter();
  @Input() modoDetalhar: boolean = false;

  constructor(private tributacaoEmpresaService: TributacaoEmpresaService) { }
  
  
  @ViewChild('filter') filter!: ElementRef;

  ngOnInit(): void {
    this.listarTributacaoEmrpesas();
  }


  listarTributacaoEmrpesas(){
    this.tributacaoEmpresaService.listarTodosPorEmpresa(this.empresa?.id).subscribe({
      next: (data: TributacaoEmpresa[]) => {
        this.listaTributacaoEmpresa = data;
      },
      error: (err: any) => {
        console.log(err);
      }
    });
  }


  editarPermissao(id: number){
    this.emissor.emit({
      id: id,
      modo: 'EDITAR'
    });
  }

  rolarTela(){
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

}
